import { useEffect } from 'react';

import FormError from '@/shared-components/error/components/FormError';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/ShippingCard.css';

export default function ShippingCard({ value, location, element, formError, previewMode, onChange, deleteException, currency=null }) {
  useEffect(() => {
    if (currency && currency !== null) {
      onChange({ ...value, currency: currency });
    }
  }, [currency]);

  return (
    <>
      <div className="add-artwork-shipping__shipping-card-outter">
        <div className={`add-artwork-shipping__shipping-card ${value.payer==="My gallery" ? " my-gallery" : ""}`} id={element}>
          {(deleteException && !previewMode) && (
            <div className="add-artwork-shipping__shipping_card-delete" onClick={deleteException}>
              <div/>
            </div>
          )}
          <h2 className="add-artwork-shipping__shipping-card-location">
            <Heading small>{location}</Heading>
          </h2>

          <Text className="add-artwork-shipping__shipping-card-text" medium paragraph justify>Who pays for the shipping?</Text>

          <PublicFormInput 
            className="add-artwork-shipping__shipping-card-choose" 
            type="choose" 
            optionA={"The collector"}  
            optionB={"My gallery"} 
            value={value.payer}
            onChange={(payer)=>onChange(payer === "My gallery" ? { ...value, payer, currency: currency, price: "" } : { ...value, payer })} 
          />

          {value.payer !== "My gallery" &&
            <div className={`add-artwork-shipping__shipping-card-group${value.payer==="My gallery" ? " disabled" : ""}`}>
              <div className={"add-artwork-shipping__shipping-card-group-entire"}>
                <PublicFormInput 
                  placeholder="Price" 
                  type="currencyInput" 
                  element={`${element}_price`}
                  value={value.price} 
                  onChange={(e)=>onChange({ ...value, price: e.target.value })}
                  currency={currency}
                />
              </div>
            </div>
          }

        </div>
        <FormError 
          error={Array.isArray(formError) ? formError?.find(error => error.element === element): null} 
          element={element} errorClassName="add-artwork-shipping-error"/>
      </div>
    </>
  );
}
